<p>purchase-coins works!</p>
